import type { TMargem } from '@/features/simulador/shared/types/margem.types'

export class CalculadoraDeFator {
  calcularFatorAlcancado = (margens: TMargem[]): TMargem[] => {
    return margens.map((margem) => {
      const { margemRealizada = 0, margemPositiva = 0 } = margem
      const valoresValidos = margemPositiva !== 0
      let fator = valoresValidos ? margemRealizada / margemPositiva : 0
      if (margem.margemAPI < 0) fator += 1
      return { ...margem, fator }
    })
  }
}
